/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'fabric.editor.headingLink.ascSortingLabel': 'nousevassa järjestyksessä',
  'fabric.editor.headingLink.copied': 'Kopioitu!',
  'fabric.editor.headingLink.copyAnchorLink': 'Kopioi otsikkolinkki',
  'fabric.editor.headingLink.copyAriaLabel': 'Kopioi',
  'fabric.editor.headingLink.descSortingLabel': 'laskevassa järjestyksessä',
  'fabric.editor.headingLink.failedToCopy': 'Kopiointi epäonnistui',
  'fabric.editor.headingLink.noneSortingLabel': 'Ei mitään',
  'fabric.editor.inlineComment.marker.end': 'tekstin sisäisen kommentin loppu',
  'fabric.editor.inlineComment.marker.start': 'tekstin sisäisen kommentin alku',
};
